import { request, language } from '@tencent/ppd-base-libs';
import dayjs from 'dayjs';

// 线上的主题配置
export let CONF;
// 过期的主题配置
export let EXPIREDCONF;

/**
 * 获取多语言属性
 */
export function getMultiLangAttr(data, key) {
  const lang = language.getLanguage();
  if (lang === 'en' && data[`${key}_en`]) {
    return data[`${key}_en`];
  }
  if (lang === 'zh-cn' && data[`${key}_cn`]) {
    return data[`${key}_cn`];
  }
  return data[`${key}_hk`];
}

export async function cfgInit() {
  const url = 'https://st.moneydata.hk/wuji/config/goodDeedDayCfg/goodDeedDayCfg.json';
  const configList = await request.loadVtools(url);
  getOnlineCfg(configList);
  getExpiredCfg(configList);
}

// 获取在线上的配置
function getOnlineCfg(configList) {
  const cfg = configList.find(item => {
    const now = dayjs();
    const itemStartDate = dayjs(item.startDate);
    const itemEndDate = dayjs(item.endDate);
    return now.isAfter(itemStartDate) && now.isBefore(itemEndDate);
  });
  cfg.stampId = decodeURIComponent(cfg.stampId);
  cfg.globalActId = decodeURIComponent(cfg.globalActId);
  cfg.actList = cfg.actList.map(item => {
    console.log(item);
    return {
      ...item,
      enActid: decodeURIComponent(item.enActid),
      qualId: decodeURIComponent(item.qualId),
    };
  });
  CONF = cfg;
}

// 获取过期的主题配置
function getExpiredCfg(configList) {
  const expiredCfgArr = configList.filter(item => {
    const now = dayjs();
    const itemEndDate = dayjs(item.endDate);
    return now.isAfter(itemEndDate);
  });
  const fmtArr = expiredCfgArr.map((item) => {
    const actList = item.actList.map(item => {
      console.log(item);
      return {
        ...item,
        enActid: decodeURIComponent(item.enActid),
        qualId: decodeURIComponent(item.qualId),
      };
    });
    return {
      ...item,
      actList,
      stampId: decodeURIComponent(item.stampId),
      globalActId: decodeURIComponent(item.globalActId),
      startDate: dayjs(item.startDate).toDate(),
      endDate: dayjs(item.endDate).toDate(),
    };
  });
  // 按时间排序
  const sortArr = fmtArr.sort((a, b) => (dayjs(b.endDate).isAfter(dayjs(a.endDate)) ? 1 : -1));
  EXPIREDCONF = sortArr;
}

// 获取无极配置中周期列表中各个子活动的加密actid
export function getAllExpiredActId() {
  const allIdList = EXPIREDCONF.map(config => {
    const actIdList = config.actList.map(item => item.enActid);
    return actIdList;
  });
  return allIdList.flat();
}

